
/*==================================
=         TRAFFIC OVERVIEW        =
==================================*/

Vue.component('traffic_user', {
    template:'#trafficuser-template',

    data:function(){
        return{
            list: [],
            searchString:'',
            modal:'',
            activeMeetingRoomId:0,
            tasks:[]
        };
    },
    created:function(){

        activeInstance = this;
        //activeInstance.modal = $('body').find('#modal_create_meeting_room_event').html();


        showLoadingOverlay();


        activeInstance.getUserTasks();



    },

    methods:{
        /*
        refreshEventData:function(){
            showLoadingOverlay();
            Vue.http.get(baseURL+'/api/meeting_room/all',function(response){
                $('body').LoadingOverlay("hide");
                activeInstance.list=response;
                setTimeout(function(){
                    activeInstance.initializeCalendars();
                },100);
            }).bind(this);
        },
        */

        getUserTasks:function(){
            Vue.http.get(baseURL+'/api/traffic_user/tasks',function(response){
                $('body').LoadingOverlay("hide");
                activeInstance.tasks=response;
                setTimeout(function(){
                    activeInstance.initializeCalendars();
                },300);

                setTimeout(function(){
                    activeInstance.initalizeTaskHolder();
                },1000);
            }).bind(this);
        },
        initalizeTaskHolder:function() {

            activeInstance.tasks.forEach(function (task) {
                setTimeout(function(){
                    window.tippy('#task-'+task.id, {
                        //html: '#task-'+task.id+'-details'
                        html: document.querySelector('#task-'+task.id+'-details'), // DIRECT ELEMENT option
                    });
                },100);

            })
        },
        initializeCalendars:function(){

            $('#user_traffic_calendar').fullCalendar({
                defaultView: 'agendaWeek',
                minTime: "07:00:00",
                maxTime: "20:00:00",
                header: {
                    left: 'prev,next today',
                    center: 'title',
                    right: 'agendaWeek,agendaDay',
                },
                businessHours: {
                    // days of week. an array of zero-based day of week integers (0=Sunday)
                    dow: [ 1, 2, 3, 4 ], // Monday - Thursday

                    start: '09:00', // a start time (10am in this example)
                    end: '18:00', // an end time (6pm in this example)
                },
                events: activeInstance.tasks
            })

        },
        create:function(meeting_room_id){
            var current_modal= bootbox.dialog({
                title: "Új időpont lefoglalása",
                message: this.modal,
                buttons: {
                    success: {
                        label: "Save",
                        className: "btn-success",
                        callback: function () {

                            $('.error').removeClass('error');
                            var validation = true;

                            //VALIDATE EVERYTHING!!
                            var title	=  $('.bootbox-body').find('#field_title').val();
                            var start	=  $(".bootbox").find('#field_event_start').data("DateTimePicker").date();
                            var event_length	=  $(".bootbox").find('#field_event_length').find('select').val();
                            console.log(event_length);

                            if(title.length < 2){
                                validation = false;
                                errorNotification('Az esemény megnevezése túl rövid!');
                                $('.bootbox-body').find('#field_title').addClass('error');
                            }

                            if( start == null)
                            {
                                validation = false;
                                errorNotification('Az esemény kezdetét ki kell tölteni.');
                                $('.bootbox-body').find('#field_event_start').addClass('error');
                            }
                            else
                            {
                                start = moment(start).format('YYYY[-]MM[-]DD HH[:]mm');
                                console.log(start);
                                if(start.length < 16){
                                    validation = false;
                                    errorNotification('Az esemény kezdeténél nem megfelelő a formátum.');
                                    $('.bootbox-body').find('#field_event_start').addClass('error');
                                }
                            }

                            if(validation == true){

                                activeInstance.$http.post(baseURL+'/admin/meeting_room_event/request/reservation',{
                                    title:title,
                                    start:start,
                                    meeting_room_id:meeting_room_id,
                                    event_length:event_length
                                }).then(function(response){
                                    //REFRESH EVENT LIST
                                    activeInstance.getUserTasks();
                                    successNotification(response.data.message);
                                    setTimeout(function(){
                                        current_modal.modal('hide');
                                    },200);

                                }) .catch(function (error) {
                                    console.log(error.data);

                                    //IF THE REQUESTED EVENT OVERLAPS A PRESENT ONE
                                    if(error.data.odin_error_code==15001)
                                    {
                                        errorNotification(error.data.message);
                                        validation = false;
                                        $('.bootbox-body').find('#field_event_start').addClass('error');
                                        $('.bootbox-body').find('#field_event_length').addClass('error');
                                    }

                                    return false;
                                });
                                return false;
                            }
                            else{
                                return false;
                            }
                        }
                    }
                }
            });



            setTimeout(function(){
                $(function () {
                    $(".bootbox").find('#field_event_start').datetimepicker({
                        format: 'YYYY-MM-DD HH:mm',
                        locale: 'hu'
                    });
                });
            },100);
        },
    }
});